import {LoadingButton} from '@mui/lab';
import {styled} from '@mui/material';

export const RoundedLoadingButton = styled(LoadingButton)(() => ({
  borderRadius: '20px',
  textTransform: 'none',
}));
